<template>
	<div class="px-5">
		<app-table
			class="my-5 is-not-selectable pb-4"
			name="projects"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.id }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.codeProject }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.description }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Proyecto"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="business"
						text="Compañías"
						@click-icon="openCompanies(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="apps"
						text="Aplicaciones"
						@click-icon="openApps(props.row)"
					/>
					<app-tooltip-button
						color="orange"
						icon="touch_app"
						text="Barra de Acciones"
						@click-icon="openActions(props.row)"
					/>
					<app-tooltip-button
						color="success"
						icon="language"
						text="Roles Globales"
						@click-icon="goToGlobalRoles(props.row)"
					/>
					<app-tooltip-button
						color="error"
						icon="delete"
						text="Eliminar Proyecto"
						@click-icon="openModalConfirmation(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="description"
						text="Template"
						@click-icon="openTemplate(props.row)"
					/>
					<v-tooltip top>
						<v-btn
							flat
							icon
							small
							slot="activator"
							@click="goToWebServices(props.row)">
							<img 
								src="https://goo.su/KtHCWa" 
								alt="servicios"
								height="25">
						</v-btn>
						<span>Web Services</span>
					</v-tooltip>
					<app-tooltip-button
						color="blue"
						icon="build"
						text="Procesos"
						@click-icon="openProcesses(props.row)"
					/>
					<app-tooltip-button
						v-if="props.row.codeProject === 'maki_project'"
						color="blue"
						icon="receipt_long"
						text="Facturación Electronica"
						@click-icon="openBilling(props.row)"
					/>
					<v-tooltip top v-if="props.row.codeProject === 'maki_project'">
						<v-btn
							flat
							icon
							small
							slot="activator"
							color="blue"
							@click="openLevels(props.row)">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gamepad-icon lucide-gamepad"><line x1="6" x2="10" y1="12" y2="12"/><line x1="8" x2="8" y1="10" y2="14"/><line x1="15" x2="15.01" y1="13" y2="13"/><line x1="18" x2="18.01" y1="11" y2="11"/><rect width="20" height="12" x="2" y="6" rx="2"/></svg>

						</v-btn>
						<span>Niveles y Tareas</span>
					</v-tooltip>
					<v-tooltip top v-if="props.row.codeProject === 'maki_project'">
						<v-btn
							flat
							icon
							small
							slot="activator"
							color="warning"
							@click="openPromotions(props.row)">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-promotion-megaphone">
								<path d="M3 11l18-5v12L3 14v-3z"></path>
								<path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path>
								<path d="M22 9a4 4 0 0 1 0 6"></path>
								<path d="M24 7a7 7 0 0 1 0 10"></path>
							</svg>


						</v-btn>
						<span>Promociones</span>
					</v-tooltip>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appConfirmationModal from '@/components/shared/app-confirmation-modal';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import helper from '@/shared/helper';

const { setLocalData } = helper;

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`project/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
		})
		.catch((err) => {
			if (err.status === 405) {
				if (err.data.message === 'No se elimino el proyecto, tiene modulos asociados.') {
					this.showError('El proyecto no pudo ser eliminado por tener data asociada.');
				}
			}
		})
		.finally(() => {
			this.loading = false;
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		});
}

function edit({ id }) {
	this.goTo('page-project-edit', { params: { id } });
}

function openProcesses({ codeProject }) {
	this.goTo('page-process', { params: { codeProject } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openActions({ codeProject, languages }) {
	setLocalData('project-languages', languages);
	this.goTo('page-action', { params: { codeProject } });
}

function openApps({ codeProject, languages }) {
	setLocalData('project-languages', languages);
	this.goTo('page-app', { params: { codeProject } });
}

function openCompanies({ codeProject }) {
	this.goTo('page-company', { params: { codeProject } });
}

function openTemplate({ codeProject, id }) {
	setLocalData('project-id', id);
	this.goTo('page-template', { params: { codeProject, projectId: id } });
}

function goToGlobalRoles(project) {
	const { codeProject, id: projectId } = project;
	this.goTo(
		'roles-global',
		{ params: { codeProject, projectId } },
	);
}

function goToWebServices({ codeProject }) {
	this.goTo('page-web-services', { params: { codeProject } });
}
function openLevels({ codeProject }) {
	this.goTo('page-levels', { params: { codeProject } });
}
function openPromotions({ codeProject }) {
	this.goTo('page-promotions', { params: { codeProject } });
}

function openBilling({ codeProject }) {
	this.goTo('page-list-billing', { params: { codeProject } });
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'projects-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		confirm,
		edit,
		goToGlobalRoles,
		goToWebServices,
		onSearch,
		openActions,
		openApps,
		openBilling,
		openCompanies,
		openProcesses,
		openTemplate,
		openLevels,
		openPromotions,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/projects/project-list.vue